// extracted by mini-css-extract-plugin
export default {"noteBox":"NotesElements_noteBox__8BTw7","notePreview":"NotesElements_notePreview__uC9j0"};